import React, { useState, useEffect, useContext } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';

import { isEmpty, get, forIn } from 'lodash';
import WidgetSectionTitle from '../../../widgets/CustomWidgetSectionTitle';
import useAPI from 'hooks/useApi';
import AppContext from 'context/Context';
import waterIcon from 'assets/img/icons/water.svg';
import soilIcon from 'assets/img/icons/soil_param.svg';

import { useOutletContext, useParams } from 'react-router-dom';
import ErrorNotFound from 'components/errors/ErrorNotFound';
import { getProjectDetails } from 'api/endpoints/ManagementServices';

import ObservationRender from './ObservationRender';
import { getTenantFromToken } from 'utils/routeUtils';
import {
  getEnvIndicators,
  getEnvOverall
} from 'api/endpoints/Enviormental_Indicators';
import MonitoringStats from '../monitoring/MonitoringStats';
import MonitoringStatsSkeleton from '../monitoring/skeleton/MonitoringStatsSkeleton';

const HabitatMonitoring = () => {
  const { setConfig } = useContext(AppContext);
  const {
    config: { isDark }
  } = useContext(AppContext);
  const { cluster } = useParams();

  const tenant = getTenantFromToken();

  const { setApisLoading } = useOutletContext();

  const [showErrorPage, setshowErrorPage] = useState(false);

  const getProjectDetailsAPI = useAPI(getProjectDetails);
  const getHabitatMonitoringAPI = useAPI(getEnvIndicators);
  const getOverAllMonitoringAPI = useAPI(getEnvOverall);

  const [ProjectDetails, setProjectDetails] = useState({});
  const [coordinates, setCoordinates] = useState([]);
  const [overAllMonitoringData, setOverAllMonitoringData] = useState({});
  useState({});
  const [HabitatMonitoringData, setHabitatMonitoringData] = useState({});

  const apiHooks = [getOverAllMonitoringAPI, getHabitatMonitoringAPI];

  useEffect(() => {
    setConfig('cluster', cluster);
    // setshowErrorPage(false);

    if (cluster && tenant) {
      // resetApiStates(); // Reset loading and data for all APIs
      let request_id = cluster;
      getProjectDetailsAPI.request({ tenant, request_id });
    }
  }, [cluster]);

  useEffect(() => {
    const data = get(getProjectDetailsAPI.data, 'results', {});
    setProjectDetails(data);
  }, [getProjectDetailsAPI.data]);

  const performSequentialAPICalls = async currentCluster => {
    if (!currentCluster) {
      console.log('No cluster available for API calls');
      return;
    }

    setApisLoading(true);
    for (let i = 0; i < apiHooks.length; i++) {
      await apiHooks[i].request(currentCluster);
    }
    setApisLoading(false);
  };

  const resetApiStates = () => {
    for (let i = 0; i < apiHooks.length; i++) {
      apiHooks[i].setLoading(true);
    }
  };

  useEffect(() => {
    if (cluster) {
      performSequentialAPICalls(cluster);
    }
  }, [cluster]);

  useEffect(() => {
    if (
      !isEmpty(getProjectDetailsAPI.error) ||
      !isEmpty(getHabitatMonitoringAPI.error) ||
      !isEmpty(getOverAllMonitoringAPI.error)
    ) {
      setshowErrorPage(true);
    }
  }, [
    getProjectDetailsAPI.error,
    getHabitatMonitoringAPI.error,
    getOverAllMonitoringAPI.error
  ]);

  useEffect(() => {
    const data = get(getProjectDetailsAPI.data, 'results', {});
    setProjectDetails(data);
  }, [getProjectDetailsAPI.data]);

  useEffect(() => {
    if (ProjectDetails && ProjectDetails.coordinates) {
      const isMultiPolygon =
        ProjectDetails.coordinates.includes('MULTIPOLYGON');

      if (isMultiPolygon) {
        const coordinatesRegex = /\(\((.*?)\)\)/g;
        const matches = ProjectDetails.coordinates.match(coordinatesRegex);

        if (matches) {
          const formattedCoordinates = matches.map(match => {
            const coordinatesArray = match.match(/-?\d+\.\d+/g).map(Number);

            const formatted = [];
            for (let i = 0; i < coordinatesArray.length; i += 2) {
              formatted.push([coordinatesArray[i + 1], coordinatesArray[i]]);
            }
            return formatted;
          });
          setCoordinates(formattedCoordinates);
        }
      } else {
        const coordinatesArray = ProjectDetails?.coordinates
          .match(/-?\d+\.\d+/g)
          .map(Number);
        const formattedCoordinates = [];
        for (let i = 0; i < coordinatesArray.length; i += 2) {
          formattedCoordinates.push([
            coordinatesArray[i + 1],
            coordinatesArray[i]
          ]);
        }
        setCoordinates(formattedCoordinates);
      }
    }
  }, [ProjectDetails]);

  useEffect(() => {
    if (!isEmpty(getOverAllMonitoringAPI.data)) {
      setOverAllMonitoringData(
        get(getOverAllMonitoringAPI.data, 'results', {})
      );
    }
    const reportUrl = get(
      getOverAllMonitoringAPI.data,
      'results.assessment_report',
      ''
    );
    setConfig('pdfReportUrl', reportUrl);
  }, [getOverAllMonitoringAPI.data]);

  useEffect(() => {
    if (!isEmpty(getHabitatMonitoringAPI.data)) {
      setHabitatMonitoringData(
        get(getHabitatMonitoringAPI.data, 'results', {})
      );
    }
  }, [getHabitatMonitoringAPI.data]);

  // Assuming your array is called features

  const habitatObservation = get(
    HabitatMonitoringData,
    'environmental_indicators',
    {}
  );

  const overallScore = get(overAllMonitoringData, 'overall_score', {});

  const overallData = [];
  forIn(overallScore, (value, key) => {
    overallData.push({
      title: key === 'green_cover' ? 'Green Cover' : key,
      suffix: '%',
      ...overallScore[key]
    });
  });

  return (
    <>
      {showErrorPage ? (
        <ErrorNotFound />
      ) : (
        <>
          <Row className="g-3 mb-3 mt-1">
            <Col md="12" className="mt-0">
              {isEmpty(overAllMonitoringData?.asessment_details) ||
              getOverAllMonitoringAPI.loading ? (
                <MonitoringStatsSkeleton />
              ) : (
                <MonitoringStats
                  data={overAllMonitoringData?.asessment_details}
                />
              )}
            </Col>
          </Row>
          {/* <Row className="g-3 mb-3">
            {getOverAllMonitoringAPI.loading ? (
              <StatiticsCardsSkeleton />
            ) : !isEmpty(overallData) ? (
              overallData?.map((stat, index) => (
                <Col md={4} key={index}>
                  <StatisticsCard
                    stat={stat}
                    style={{ minWidth: '12rem', height: '100%' }}
                    index={index}
                  />
                </Col>
              ))
            ) : (
              <></>
            )}
          </Row> */}

          {!isEmpty(habitatObservation) && (
            <WidgetSectionTitle
              icon={soilIcon}
              title="Habitat Monitoring"
              transform="shrink-4"
              className="mb-4 mt-4 align-items-center"
              light={true}
            />
          )}

          <Row className="g-3 mb-3">
            <ObservationRender
              key={'habitatObservation'}
              observation={habitatObservation}
              loading={getHabitatMonitoringAPI.loading}
              coordinates={coordinates}
            />
          </Row>
        </>
      )}
    </>
  );
};

export default HabitatMonitoring;
